import React from 'react';
import { column, row } from 'core/style';
import { WithStyles, ITheme } from 'core/style/interfaces';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import Textbook, { ITextbook } from './Textbook';

type ITextbookListProps = {} & WithStyles<typeof styles>;

export const textbookList: ITextbook[] = [
    {
        // Хардкод id Лекторов с прода, чтобы работали линки на преподавателей
        lecturers: [{ account: { id: 5, firstName: 'Станислав', lastName: 'Говоров' }, id: 5 }],
        title: '15 первых шагов в инвестициях на бирже',
        subTitle:
            '15 первых шагов, которые должен сделать каждый инвестор, чтобы потом его инвестиции приносили прибыль',
        price: 0,
        buttonTitle: 'Забрать себе',
        externalLink: 'https://t.me/redcircule_distribution_bot',
        includes: 'Пособие в формате PDF',
        pictureUrl: './pictures/15step.png',
    },
    {
        lecturers: [{ account: { id: 5, firstName: 'Станислав', lastName: 'Говоров' }, id: 5 }],
        title: 'Ошибки инвестора',
        subTitle: 'Как избежать ошибок, которые совершают 99% инвесторов, и не потерять капитал на фондовом рынке',
        price: 0,
        buttonTitle: 'Забрать себе',
        externalLink: 'https://t.me/redcircule_distribution_bot',
        includes: 'Пособие в формате PDF',
        pictureUrl: './pictures/mistakes.png',
    },
    {
        lecturers: [{ account: { id: 5, firstName: 'Станислав', lastName: 'Говоров' }, id: 5 }],
        title: 'Робоэдвайзеры. Краткий курс',
        subTitle: 'Курс, который поможет разобраться, что такое робоэдвайзинг, и нужен ли он вам',
        price: 0,
        buttonTitle: 'Забрать себе',
        externalLink: 'https://red-circule.com/courses/11923',
        includes: 'Пособие в формате PDF',
        pictureUrl: './pictures/roboedvaizer.jpg',
    },
    {
        lecturers: [{ account: { id: 2, firstName: 'Павел', lastName: 'Пахомов' }, id: 2 }],
        title: 'Опционы в кармане',
        subTitle: '15 минут, чтобы разобраться с опционами и понять, зачем они нужны',
        price: 0,
        buttonTitle: 'Забрать себе',
        externalLink: 'https://t.me/rc_fo_bot',
        includes: 'Пособие в формате PDF',
        pictureUrl: './pictures/pocket_options.png',
    },
];

const TextbookList: React.FC<ITextbookListProps> = ({ classes }) => {
    return (
        <div className={classes.list}>
            {textbookList.map(elem => (
                <div className={classes.item} key={elem.title}>
                    <Textbook textbook={elem} />
                </div>
            ))}
        </div>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        list: {
            ...row(),
        },
        item: {
            ...column(),
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '1.5rem',
            [theme.breakpoints.up('sm')]: {
                ...column({ cols: 6 }),
            },
            [theme.breakpoints.up('md')]: {
                ...column({ cols: 4 }),
            },
        },
    });

export default injectSheet(styles, 'TextbookList')(TextbookList);
